import * as React from "react";
const PlusSvg = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.25 0.5H1.75C1.41848 0.5 1.10054 0.631696 0.866116 0.866116C0.631696 1.10054 0.5 1.41848 0.5 1.75V14.25C0.5 14.5815 0.631696 14.8995 0.866116 15.1339C1.10054 15.3683 1.41848 15.5 1.75 15.5H14.25C14.5815 15.5 14.8995 15.3683 15.1339 15.1339C15.3683 14.8995 15.5 14.5815 15.5 14.25V1.75C15.5 1.41848 15.3683 1.10054 15.1339 0.866116C14.8995 0.631696 14.5815 0.5 14.25 0.5ZM12.375 8.625H8.625V12.375C8.625 12.5408 8.55915 12.6997 8.44194 12.8169C8.32473 12.9342 8.16576 13 8 13C7.83424 13 7.67527 12.9342 7.55806 12.8169C7.44085 12.6997 7.375 12.5408 7.375 12.375V8.625H3.625C3.45924 8.625 3.30027 8.55915 3.18306 8.44194C3.06585 8.32473 3 8.16576 3 8C3 7.83424 3.06585 7.67527 3.18306 7.55806C3.30027 7.44085 3.45924 7.375 3.625 7.375H7.375V3.625C7.375 3.45924 7.44085 3.30027 7.55806 3.18306C7.67527 3.06585 7.83424 3 8 3C8.16576 3 8.32473 3.06585 8.44194 3.18306C8.55915 3.30027 8.625 3.45924 8.625 3.625V7.375H12.375C12.5408 7.375 12.6997 7.44085 12.8169 7.55806C12.9342 7.67527 13 7.83424 13 8C13 8.16576 12.9342 8.32473 12.8169 8.44194C12.6997 8.55915 12.5408 8.625 12.375 8.625Z"
      fill="#3C163B"
    />
  </svg>
);
export default PlusSvg;
